import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { defaults } from 'react-sweet-state';
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import ErrorBoundary from "react-components/ErrorBoundary";
import { BackdropProvider } from "react-components/BackdropProvider";
import { GlobalSpinnerProvider } from "react-components/GlobalSpinnerProvider";
import Theme from 'react-common/theme';
import { appUrl } from 'utils';
import { TourSearchStoreContainer } from '../../store/TourSearchStoreContainer';
import { TourDescriptionStoreContainer } from '../../store/TourDescriptionStoreContainer';
import { TourDescriptionContainer } from '../TourDescription';
import TourSearchResultsContainer from '../TourSearchResults/TourSearchResultsContainer';
import { SnackbarProvider } from 'notistack';
defaults.devtools = true;
/**
 * Корневой элемент поиска туров.
 * @param initialState Поисковые результаты
 */
function TourSearchRoot(initialState) {
    var _a, _b;
    const searchState = initialState.type == 'search-state' ? initialState : undefined;
    const descState = initialState.type == 'description-state' ? initialState : initialState.flightConfiguration ? { flightConfiguration: initialState.flightConfiguration } : undefined;
    return (React.createElement(BackdropProvider, null,
        React.createElement(GlobalSpinnerProvider, null,
            React.createElement(ErrorBoundary, null,
                React.createElement(ThemeProvider, { theme: Theme },
                    React.createElement(SnackbarProvider, { maxSnack: 3, anchorOrigin: { vertical: 'top', horizontal: 'right' }, domRoot: document.body, classes: { containerRoot: 'snackbar-root' } },
                        React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
                            React.createElement(Router, null,
                                React.createElement(Switch, null,
                                    React.createElement(Route, { path: appUrl("/Tour/SearchResult") },
                                        React.createElement(TourSearchStoreContainer, { initialState: searchState, isGlobal: true },
                                            React.createElement(TourSearchResultsContainer, null))),
                                    React.createElement(Route, { path: appUrl("/Tour/:id/view/:hash/:slug?") },
                                        React.createElement(TourDescriptionStoreContainer, { initialState: descState },
                                            React.createElement(TourDescriptionContainer, { isFrame: false, hash: (_b = (_a = descState === null || descState === void 0 ? void 0 : descState.description) === null || _a === void 0 ? void 0 : _a.priceItem) === null || _b === void 0 ? void 0 : _b.servicesHash }))),
                                    React.createElement(Route, { path: appUrl("/Tour/:id/:slug?") },
                                        React.createElement(TourDescriptionStoreContainer, { initialState: descState },
                                            React.createElement(TourDescriptionContainer, { isFrame: false, hash: undefined }))))))))))));
}
export default TourSearchRoot;
